import { AppState, HomePageCuscoAppState } from '../../../initialStateRegistration';
import { HomePageCuscoBannerSection, HomePageCuscoImageLinksSection, HomePageCuscoMinorSections } from './homePageCusco.initialState';

export const getHomePage = (state: AppState) => (state as HomePageCuscoAppState).template;

export const getSectionDataByKey = (key: HomePageCuscoMinorSections) => (state: AppState) => getHomePage(state)[key];

export const getSectionArticlesByKey = (key: HomePageCuscoMinorSections) => (state: AppState) => getHomePage(state)[key].articles;

export const getSectionTitleByKey = (key: HomePageCuscoMinorSections | HomePageCuscoImageLinksSection) => (state: AppState) => getHomePage(state)[key].sectionTitle;

export const getSectionImageLinks = (key: HomePageCuscoImageLinksSection) => (state: AppState) => getHomePage(state)[key].imageLinks;

export const getSectionBanner = (key: HomePageCuscoBannerSection) => (state: AppState) => getHomePage(state)[key].image;

export const getMoreButtonTextByKey = (key: HomePageCuscoMinorSections) => (state: AppState) => getHomePage(state)[key].moreButtonText;

export const getMoreButtonSvgByKey = (key: HomePageCuscoMinorSections) => (state: AppState) => getHomePage(state)[key].moreButtonSvg;

export const getMetadataDescription = (state: AppState) => getHomePage(state).metadataDescription;

export const getMetadataTitle = (state: AppState) => getHomePage(state).metadataTitle;

export const getMetadataImage = (state: AppState) => getHomePage(state).metadataImage;

export const getHreflangData = (state: AppState) => getHomePage(state).hreflangData;
